import { useEffect, useState } from "react";
import { DotLoading } from "./LoadingComponent";
import { AnnotateIcon, PlayButtonIcon } from "../icon_templates/icons";
import { NavLink } from "react-router-dom";

import * as bootstrap from 'bootstrap';
import { useDispatch } from "react-redux";
import { setCollections } from "../common_functions/slicers";


export const Thumbnail_View = (props) => {

    const [url, setUrl] = useState('');
    const { selected_collection } = props.path;
    const { backendId, label, path } = props.path.content;
    const status = props?.path?.content ? props?.path?.content?.status : "";
    let label1=!props.path.isAnnotationNotAvailable ? label : (String(path).split('/')).slice(-1)[0];
    const collectionID = props.path.collectionId;
    const [isLoading, setIsLoading] = useState(false);
    const { setIsSidebarOpen,isSidebarOpen } = props;
    const [showSideView, setShowSideView] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [videoDetails, setVideoDetails] = useState({
        path: "",
        backendId: ""
    });
    const dispatch = useDispatch();

    //console.log(collection, "<**> thumnailview");
    function getThumbnailView(path, backendId) {
        setIsLoading(true);
        fetch(`/api/v1/fetch/thumb/${backendId}/${path}`, {
            method: "GET",
        }).then(async (response) => {
            if (!response.ok) {
                const err = await response.json();
                //throw err;
            }
            return await response.blob()
        })
            .then(async (data) => {
                let objectURL = await URL.createObjectURL(data);
                //console.log(objectURL);
                setUrl(objectURL);
                setIsLoading(false);
            })
            .catch(error => {
                console.error(error)
                setIsLoading(false);
            });
    }



    const show_side_detailed_view = (e) => {
        e.stopPropagation();

        dispatch(setCollections({
            path: path,
            backendId: backendId
        }))
        setIsSidebarOpen(true)
    }

    const getImageFileUrl=(imagePath,backendId)=>{
        fetch(`/api/v1/fetch/thumb/${backendId}/${imagePath}`, {
            method: "GET",
          }).then(response => response.blob())
            .then(data => {
              let objectURL = URL.createObjectURL(data);
              setUrl(objectURL);
            })
            .catch(error => console.log(error))
    }

    useEffect(() => {
        if(String(path).includes('.mp4')){
        getThumbnailView(path, backendId);
    }else{
        getImageFileUrl(path, backendId)
    }
    }, [path, backendId])
    return (
      <>
        <div
          className='card bg-transparent exp-direc'
          title={label1.replace("/", "")}
        >
          {!isLoading ? (
            <img
              src={url}
              className='card-img-top'
              alt='...'
              onClick={() =>
                props?.path?.checkedState &&
                props?.path?.checkedState.length > 0 &&
                props?.path?.handleFileSelect &&
                props?.path?.handleFileSelect(props?.path?.index, !props?.path?.checkedState[props?.path?.index])
              }
            />
          ) : (
            <span className='card-img-top p-5 d-flex justify-content-center bg-dark'>
              <DotLoading />
            </span>
          )}
          {status!='' && <div className="status-container" style={{backgroundColor:status=='Not Started' ? 'red' : status=='In-Progress' ? 'blue' : status=='Completed' ? 'green' : '',position:'absolute',height:'15px'}}>
            <p className="text-white fw-bold" style={{fontSize:'10px'}}>{status}</p>
          </div>}
          {label1.endsWith(".mp4") && (
            <div className='btn-n-list'>
              <button
                className='btn btn-dark rounded-0 playButton'
                style={{
                  width: `${!props.path.isAnnotationNotAvailable ? "50%" : "100%"}`,
                }}
                onClick={(e) => {
                  show_side_detailed_view(e);
                }}
                title='play'
              >
                <PlayButtonIcon /> Play
              </button>
              {!props.path.isAnnotationNotAvailable ? (
                props.path.collectionLabelSet &&
                props.path.collectionLabelSet.length > 0 ? (
                  <NavLink
                    title='Annotate'
                    to={`/annotator?backendId=${backendId}&collectionPath=${path}&collectionID=${collectionID}`}
                    className='btn btn-primary rounded-0 playButton nav-link nav-link-annotator'
                    target='_blank'
                  >
                    <AnnotateIcon />
                    Annotate
                  </NavLink>
                ) : (
                  <NavLink
                    onClick={props.path.handleLabelSetUnavailability}
                    className='btn btn-primary rounded-0 playButton nav-link nav-link-annotator'
                  >
                    <AnnotateIcon />
                    Annotate
                  </NavLink>
                )
              ) : (
                ""
              )}
            </div>
          )}
          <div className='card-body'>
            <h5 className='card-title'>
              <div
                style={{
                  fontSize: "0.825rem",
                  width: "100%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
                title={
                  !props.path.isAnnotationNotAvailable
                    ? label1.replace("/", "")
                    : String(path).split("/").slice(-1)[0]
                }
              >
                {!props.path.isAnnotationNotAvailable
                  ? label1.replace("/", "")
                  : String(path).split("/").slice(-1)[0]}
              </div>
            </h5>
          </div>
        </div>
      </>
    );
}